import Icon, { IconName } from "components/atoms/Icon";
import React, { ReactNode, useMemo } from "react";
import {
  Tab as ReactTab,
  TabProps as ReactTabProps,
  Tabs as ReactTabs,
} from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

export { TabList, TabPanel } from "react-tabs";

interface TabsProps {
  modifiers?: string[];
  children: ReactNode;
  defaultIndex?: number;
  selectedIndex?: number;
  onSelect?: any;
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({
  modifiers,
  className,
  selectedIndex,
  onSelect,
  children,
}) => (
  <ReactTabs
    className={joinClassnames(
      mapMultiClassnames("m-tabs", modifiers),
      className,
    )}
    selectedIndex={selectedIndex}
    forceRenderTabPanel
    onSelect={onSelect}
  >
    {children}
  </ReactTabs>
);

interface TabProps extends Partial<ReactTabProps> {
  active?: boolean;
  iconName?: IconName;
  iconActive?: IconName;
  description?: string;
  className?: string;
}
export const Tab: React.FC<TabProps> & { tabsRole: string } = ({
  active,
  iconName,
  iconActive,
  description,
  className,
  ...props
}) => {
  const tabIcon: IconName = useMemo(
    () =>
      iconName && active
        ? ((iconName.toString() + "-blue") as IconName)
        : iconName,
    [active, iconName],
  );

  return (
    <ReactTab {...props} className={className}>
      {iconName && (
        <span className="bg-icon">
          <Icon iconName={tabIcon} />
        </span>
      )}
      {props.children}
      {iconActive && (
        <span className="bg-icon">
          <Icon iconName={iconActive} />
        </span>
      )}
    </ReactTab>
  );
};

Tab.tabsRole = "Tab";
